import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import React from 'react';
import 'primeflex/primeflex.css';



const UnauthorizedView = () => {

    const user =  localStorage.getItem('loggedInUserEmail');
    localStorage.removeItem('loggedInUserName');
    localStorage.removeItem('loggedInUserEmail');

    return (   
        <div> {user} not authorized </div> 
    )
};

export default UnauthorizedView;